import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const TableHeaderCell = styled(Typography.TextH6_14_20)<{
    flex: number;
    minWidth?: number;
}>(
    ({ flex, minWidth, theme: { fontWeight } }) => css`
        align-items: center;
        display: flex;
        flex: ${flex};
        font-weight: ${fontWeight.bold};
        min-width: ${minWidth}px;
        padding-right: 12px;

        @media (max-width: ${breakpoints.md}px) {
            &:last-of-type {
                padding-right: 0;
            }
        }
    `,
);

export const TableHeader = styled.div`
    align-items: center;
    display: flex;
    padding: 0 40px 20px 16px;
    position: relative;

    @media (max-width: ${breakpoints.md}px) {
        padding: 0 18px 16px;
    }
`;
